import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks'
import { RoundedCloseIcon } from '../../ui/icons/CloseIcon'
import { DocumentIcon } from '../../ui/icons/documentIcon'
import { EnvelopeIcon } from '../../ui/icons/EnvelopeIcon'
import { RoundedPlusIcon } from '../../ui/icons/RoundedPlusIcon'
import { ButtonComponent } from '../../ui/molecules/button/newButton'
import { MadfarmInput } from '../../ui/molecules/input/newInput'
import MultiSelectCheckbox from '../../ui/molecules/multiSelectCheckbox'
import { ProtocolSearch } from '../../ui/molecules/ProtocolSearch'
import { MadfarmStaticSelect } from '../../ui/molecules/select/newSelect/static'
import TextArea from '../../ui/molecules/textArea'
import { OptionType } from '../../utils'
import { CodexSampleChangeStatusEnum } from './dataService/dto'
import { CodexSamplesAssignment, CodexSamplesCreation, GetAllCodexSamples, resetCodexSampleAssigmentResponse, resetCodexSampleAssignmentRequest, resetCodexSampleCreationRequest, resetCodexSamplesAssigmentStatus, resetCodexSamplesCreationResponse, resetCodexSamplesCreationStatus, resetGetAllCodexSamplesStatus, setCodexSampleAssignmentEntryProtocolId, setCodexSampleAssignmentEnvelopeNumbers, setCodexSampleAssignmentNote, setCodexSampleAssignmentPersonalManagementId, setCodexSampleCreationFromEnvelopeNumber, setCodexSampleCreationToEnvelopeNumber } from './slice'

export function GestionePrelieviLoadAssign() {
    const dispatch = useAppDispatch()
    const codexSampleState = useAppSelector(state => state.codexSample)
    const [loadErrorFrom, setLoadErrorFrom] = useState<boolean>(false)
    const [loadErrorTo, setLoadErrorTo] = useState<boolean>(false)
    const [stockEnvelopes, setStockEnvelopes] = useState<OptionType[]>([])
    const [selectedEnvelopes, setSelectedEnvelopes] = useState<OptionType[]>([])

    const addZerosToNumber = (envelopNumber: string) =>
        `${Array(7 - envelopNumber.length).fill('0').join('')}${envelopNumber}`

    useEffect(() => {
        dispatch(GetAllCodexSamples({ itemsPerPage: 0, page: 0, status: CodexSampleChangeStatusEnum.IN_GIACENZA }))
    }, [])

    useEffect(() => {
        if (codexSampleState.getAllCodexSamplesStatus === 'successfully' && codexSampleState.getAllCodexSampleResponse !== undefined) {
            dispatch(resetGetAllCodexSamplesStatus())
            const options: OptionType[] = codexSampleState.getAllCodexSampleResponse.data.map(env => ({
                value: String(env.envelopNumber),
                label: addZerosToNumber(String(env.envelopNumber)),
            }))
            setStockEnvelopes(options)
        }
    }, [codexSampleState.getAllCodexSamplesStatus])

    useEffect(() => {
        if (codexSampleState.codexSamplesCreationStatus === 'successfully') {
            dispatch(resetCodexSampleCreationRequest())
            dispatch(resetCodexSamplesCreationStatus())
            dispatch(GetAllCodexSamples({ itemsPerPage: 0, page: 0, status: CodexSampleChangeStatusEnum.IN_GIACENZA }))
        }
    }, [codexSampleState.codexSamplesCreationStatus])

    useEffect(() => {
        if (codexSampleState.codexSamplesAssigmentStatus === 'successfully') {
            dispatch(resetCodexSampleAssignmentRequest())
            dispatch(resetCodexSamplesAssigmentStatus())
            setSelectedEnvelopes([])
            dispatch(GetAllCodexSamples({ itemsPerPage: 0, page: 0, status: CodexSampleChangeStatusEnum.IN_GIACENZA }))
        }
    }, [codexSampleState.codexSamplesAssigmentStatus])

    return (
        <div className="flex flex-col gap-6">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Buste Prelievo Campioni </span>
                    <span className="text-brandPrimary-300 font-semibold">/</span>
                    <span className="text-brandPrimary-100 font-semibold uppercase"> Carica</span>
                </div>

                <div className="p-6 flex flex-col gap-6">
                    <p className="text-sm font-semibold text-brandPrimary-700 text-left">Carica nuove Buste Prelievo Campioni</p>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end pb-6 border-b border-neutral-200">
                        <MadfarmInput
                            label="Dal n."
                            placeholder="Specifica n. busta di partenza..."
                            value={codexSampleState.codexSamplesCreationRequest.fromEnvelopNumber}
                            onChangeText={(text) => dispatch(setCodexSampleCreationFromEnvelopeNumber(text))}
                            error={loadErrorFrom}
                            supportingText={loadErrorFrom ? 'N. busta di partenza mancante' : undefined}
                        />
                        <MadfarmInput
                            label="Al n."
                            placeholder="Specifica n. busta di arrivo..."
                            value={codexSampleState.codexSamplesCreationRequest.toEnvelopNumber}
                            onChangeText={(text) => dispatch(setCodexSampleCreationToEnvelopeNumber(text))}
                            error={loadErrorTo}
                            supportingText={loadErrorTo ? 'N. busta di arrivo mancante' : undefined}
                        />
                        <ButtonComponent
                            size="lg"
                            iconPosition="left"
                            icon={<RoundedPlusIcon />}
                            variant="solid"
                            color="orange"
                            label="Aggiungi Buste"
                            onClick={() => dispatch(CodexSamplesCreation(codexSampleState.codexSamplesCreationRequest))}
                        />
                    </div>
                    {codexSampleState.codexSamplesCreationResponse && (
                        <div className="flex flex-col gap-3">
                            {codexSampleState.codexSamplesCreationResponse.successEnvelopNumbers.length > 0 && (
                                <div className="flex items-center gap-4">
                                    <div className="w-1 h-12 rounded bg-green-500 shrink-0" />
                                    <div className="flex items-center gap-6 flex-1">
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Dal n.</div>
                                            <div className="text-sm text-green-600">{addZerosToNumber(codexSampleState.codexSamplesCreationResponse.successEnvelopNumbers[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Al n.</div>
                                            <div className="text-sm text-green-600">{addZerosToNumber(codexSampleState.codexSamplesCreationResponse.successEnvelopNumbers.slice(-1)[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Stato</div>
                                            <div className="text-sm text-green-600">In Giacenza</div>
                                        </div>
                                        <button onClick={() => dispatch(resetCodexSamplesCreationResponse())}>
                                            <RoundedCloseIcon color="#166428" />
                                        </button>
                                    </div>
                                </div>
                            )}
                            {codexSampleState.codexSamplesCreationResponse.failedEnvelopNumbers.length > 0 && (
                                <div className="flex items-center gap-4">
                                    <div className="w-1 h-12 rounded bg-red-500 shrink-0" />
                                    <div className="flex items-center gap-6 flex-1">
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-red-700">Buste già esistenti — Dal n.</div>
                                            <div className="text-sm text-red-600">{addZerosToNumber(codexSampleState.codexSamplesCreationResponse.failedEnvelopNumbers[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-red-700">Al n.</div>
                                            <div className="text-sm text-red-600">{addZerosToNumber(codexSampleState.codexSamplesCreationResponse.failedEnvelopNumbers.slice(-1)[0])}</div>
                                        </div>
                                        <button onClick={() => dispatch(resetCodexSamplesCreationResponse())}>
                                            <RoundedCloseIcon color="#940500" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Buste Prelievo Campioni </span>
                    <span className="text-brandPrimary-300 font-semibold">/</span>
                    <span className="text-brandPrimary-100 font-semibold uppercase"> Assegna</span>
                </div>

                <div className="p-6 flex flex-col gap-6">
                    <MadfarmStaticSelect
                        menuPortalTargetIsNotBody
                        label="Tecnico Ispettore"
                        placeholder="Seleziona ispettore..."
                        options={codexSampleState.PMResources}
                        value={codexSampleState.codexSamplesAssigmentRequest.personalManagementId}
                        onChange={(value) => {
                            //@ts-ignore
                            dispatch(setCodexSampleAssignmentPersonalManagementId(value?.value))
                        }}
                        errorLabel="Ispettore mancante"
                        noOptionsMessage={""}
                    />

                    <div className="pb-6 border-b border-neutral-200">
                        <MultiSelectCheckbox
                            label="Elenco Buste per prelievo campioni da assegnare"
                            errorLabel="Non è stata selezionata alcuna busta!"
                            onChange={(e) => {
                                setSelectedEnvelopes(e.value)
                                dispatch(setCodexSampleAssignmentEnvelopeNumbers(e.value))
                            }}
                            value={selectedEnvelopes}
                            option={stockEnvelopes}
                            placeholder="Buste da assegnare"
                            selectAllLabel="Tutte"
                        />
                    </div>

                    <div className="border-t border-neutral-200 pt-2">
                        <p className="text-md font-semibold uppercase tracking-widest text-brandPrimary-600">Protocollo Invio</p>
                    </div>
                    <div className="pb-6 border-b border-neutral-200">
                        <ProtocolSearch
                            value={codexSampleState.codexSamplesAssigmentRequest.entryProtocolId}
                            type="departure"
                            onSelect={(value) => dispatch(setCodexSampleAssignmentEntryProtocolId(value))}
                        />
                    </div>

                    <TextArea
                        label="Note"
                        value={codexSampleState.codexSamplesAssigmentRequest.note}
                        onChangeText={(value) => dispatch(setCodexSampleAssignmentNote(value))}
                    />

                    <div className="flex flex-wrap gap-4">
                        <ButtonComponent
                            size="md"
                            iconPosition="left"
                            icon={<EnvelopeIcon />}
                            variant="solid"
                            color="orange"
                            label="Assegna Buste Prelievo Campioni"
                            onClick={() => dispatch(CodexSamplesAssignment(codexSampleState.codexSamplesAssigmentRequest))}
                        />
                        <ButtonComponent
                            size="md"
                            iconPosition="left"
                            icon={<DocumentIcon color="#fff" />}
                            variant="outline"
                            color="gray"
                            label="Stampa Lettera di Consegna"
                        />
                    </div>

                    {codexSampleState.codexSamplesAssigmentResponse && (
                        <div className="flex flex-col gap-3">
                            {codexSampleState.codexSamplesAssigmentResponse.successEnvelopNumbers.length > 0 && (
                                <div className="flex items-center gap-4">
                                    <div className="w-1 h-12 rounded bg-green-500 shrink-0" />
                                    <div className="flex items-center gap-6 flex-1">
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Buste correttamente assegnate — Dal n.</div>
                                            <div className="text-sm text-green-600">{addZerosToNumber(codexSampleState.codexSamplesAssigmentResponse.successEnvelopNumbers[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Al n.</div>
                                            <div className="text-sm text-green-600">{addZerosToNumber(codexSampleState.codexSamplesAssigmentResponse.successEnvelopNumbers.slice(-1)[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-green-700">Stato</div>
                                            <div className="text-sm text-green-600">Consegnate</div>
                                        </div>
                                        <button onClick={() => dispatch(resetCodexSampleAssigmentResponse())}>
                                            <RoundedCloseIcon color="#166428" />
                                        </button>
                                    </div>
                                </div>
                            )}
                            {codexSampleState.codexSamplesAssigmentResponse.failedEnvelopNumbers.length > 0 && (
                                <div className="flex items-center gap-4">
                                    <div className="w-1 h-12 rounded bg-red-500 shrink-0" />
                                    <div className="flex items-center gap-6 flex-1">
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-red-700">Errore nell'assegnazione — Dal n.</div>
                                            <div className="text-sm text-red-600">{addZerosToNumber(codexSampleState.codexSamplesAssigmentResponse.failedEnvelopNumbers[0])}</div>
                                        </div>
                                        <div className="text-left">
                                            <div className="text-xs font-semibold text-red-700">Al n.</div>
                                            <div className="text-sm text-red-600">{addZerosToNumber(codexSampleState.codexSamplesAssigmentResponse.failedEnvelopNumbers.slice(-1)[0])}</div>
                                        </div>
                                        <button onClick={() => dispatch(resetCodexSampleAssigmentResponse())}>
                                            <RoundedCloseIcon color="#940500" />
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}